<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('service.services') }}</span>
        <h3 class="page-title">{{ $t('service.group.addNewServiceGroup') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/zdobienia/grupy')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>
        <d-button theme="success" @click.prevent="validateForm">
          <i class="material-icons">add</i>
          {{ $t('service.group.addGroup') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form :class="{ 'is-loading': !allDataLoaded }">
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            :title="$t('ui.generalInfo')"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('ui.generalInfo') }}
            </h4>

            <validation-observer ref="services-group-new-form" tag="form">
              <div class="form-group">
                <label>
                  {{ $t('service.group.serviceGroupName') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('service.group.serviceGroupCode') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="code"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="code" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('service.embroidery.type') }}:
                </label>
                <div
                  class="form-control is-select">
                  <v-select
                    :options="embroideryTypes"
                    v-model="embroidery_type_id"
                    :placeholder="$t('service.chooseEmbroideryType')"
                    :reduce="embroideryType => embroideryType.id"
                    :searchable="false"
                    label="name">
                  </v-select>
                </div>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('service.group.assortmentGroupName') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="assortment_group"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="assortment_group" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('service.group.serviceGroupPhoto') }}:
                </label>

                <file-input
                  :onChange="setServiceImage"
                  id="inputFileServiceImage" />
              </div>
            </validation-observer>
          </d-tab>
          <d-tab :title="$t('service.group.servicesVariants')">
            <p class="text-center">
              {{ $t('service.group.addingServiceVariantsAvailableAfterSave') }}
            </p>
          </d-tab>

          <d-tab :title="$t('settings.transaltion.translations')">
            <p class="text-center">
              {{ $t('service.group.addingTransialtionsAvailableAfterSave') }}
            </p>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'services-group-new',
  computed: {
    allDataLoaded () {
      return this.loadedEmbroideryItems;
    },
    embroideryTypes () {
      let langToUse = this.$store.getters.getUserLang;

      if (!this.embroideryItems || !this.embroideryItems.types) {
        return [];
      }

      return this.embroideryItems.types.map(item => {
        let availableTranslation = item.translations.filter(translation => translation.language_id === langToUse);
        let itemName = item.name;

        if (availableTranslation.length) {
          itemName = availableTranslation[0].name;
        }

        return {
          id: item.id,
          name: itemName
        };
      });
    }
  },
  data() {
    return {
      name: '',
      code: '',
      image: '',
      embroidery_type_id: null,
      assortment_group: '',
      // helpers
      embroideryItems: [],
      loadedEmbroideryItems: false,
      loadError: false
    };
  },
  mounted () {
    FormUtils.loadAdditionalData(this, {
      endpoint: '/embroidery/items',
      loadedKey: 'loadedEmbroideryItems',
      outputKey: 'embroideryItems',
      errorKey: 'loadError'
    });
  },
  methods: {
    setServiceImage (event) {
      this.image = event.target.files[0];
    },
    validateForm () {
      FormUtils.validate(this.$refs['services-group-new-form'], this.submitForm);
    },
    submitForm () {
      let imageFields = false;
      let formDataToSend = {
        name: this.name,
        code: this.code,
        assortment_group: this.assortment_group,
        embroidery_type_id: this.embroidery_type_id
      };

      if (this.image) {
        formDataToSend.image = this.image;
        imageFields = ['image'];
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/services/groups/store',
        formData: formDataToSend,
        successTitle: this.$t('service.group.addServiceGroupSuccessTitle'),
        successText: this.$t('service.group.addServiceGroupSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('service.group.addServiceGroupErrorText'),
        successAction: (responseData) => {
          this.$router.push('/zdobienia/grupy/edycja/' + parseInt(responseData.id, 10))
        }
      }, imageFields);
    }
  }
};
</script>

<style lang="scss" scoped>
form.is-loading {
  opacity: .25;
  pointer-events: none;
}
</style>
